import { render, staticRenderFns } from "./pelunasanwo.vue?vue&type=template&id=1fc11337&"
import script from "./pelunasanwo.vue?vue&type=script&lang=js&"
export * from "./pelunasanwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports